enum TimePeriod {
  all = 'all',
  day = 'day',
  week = 'week',
  month = 'month',
}

export default TimePeriod;
